export default [
  { title: 'Repair', value: 'repair' },
  { title: 'Gen. Task', value: 'task' },
  { title: 'Contact Customer', value: 'customer' },
]
